import { ProjectProperties } from 'fsxa-api'

export const projectLanguages : string[] = []

// Note: They currently only store in one language!
export const projectProperties : Map<string, ProjectProperties> = new Map<string, ProjectProperties>()
export const PROPERTIES_KEY = 'properties'
